export const generateRealtimeChannelNameEventKey = (event: string): string =>
  event.replace(/_/, '-');
